import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import useAPI from "../../../../api/hooks/useAPI";
import {
  asanaTicketKeys,
  controlKeys,
  jiraIssuesKeys,
  serviceNowTicketKeys,
  ticketKeys,
} from "../../../../api/queryKeys";
import { Toast } from "../../../../components/Toast";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";
import SecondaryButton from "../../../../components/buttons/SecondaryButton";
import { StyledTextField } from "../../../../components/forms/styles/formFieldStyles";

const IssueLinkingModal = ({
  open,
  onClose,
  gapId = null,
  misconfigurationId = null,
  vulnerabilityId = null,
  tool = "Jira",
  ticketType = "issue",
}) => {
  const queryClient = useQueryClient();
  const {
    linkExistingJiraIssue,
    linkExistingAsanaTask,
    linkExistingServiceNowIncident,
  } = useAPI();
  const [ticketUrl, setTicketUrl] = useState("");

  const handleLinkIssue = async () => {
    if (!ticketUrl) {
      alert(`${tool} ${ticketType} link is required!`);
      return false;
    }

    try {
      if (tool === "Jira") {
        await linkExistingJiraIssue(
          ticketUrl,
          gapId,
          misconfigurationId,
          vulnerabilityId
        );
        queryClient.invalidateQueries({ queryKey: jiraIssuesKeys.all });
      } else if (tool === "Asana") {
        await linkExistingAsanaTask(ticketUrl, gapId, misconfigurationId);
        queryClient.invalidateQueries({ queryKey: asanaTicketKeys.all });
      } else if (tool === "ServiceNow") {
        await linkExistingServiceNowIncident(
          ticketUrl,
          gapId,
          misconfigurationId
        );
        queryClient.invalidateQueries({ queryKey: serviceNowTicketKeys.all });
      }
      queryClient.invalidateQueries({ queryKey: ticketKeys.all });
      queryClient.invalidateQueries({
        queryKey: controlKeys.controlActivityLogs(gapId),
      });
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  const handleSave = async () => {
    try {
      const res = await handleLinkIssue();
      onClose();
      if (res) {
        Toast.success(`${tool} ${ticketType} linked successfully!`);
      } else {
        Toast.error(`Failed to link ${tool} ${ticketType}.`);
      }
    } catch (error) {
      Toast.error(`Failed to link ${tool} ${ticketType}.`);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <Box sx={{ width: "500px" }}>
        <DialogTitle>
          <Typography variant="subtitle1">
            Link Existing {tool} {ticketType}
          </Typography>
        </DialogTitle>

        <DialogContent>
          <StyledTextField
            label={
              <Typography variant="caption">{`${tool} ${ticketType} URL`}</Typography>
            }
            value={ticketUrl}
            onChange={(e) => setTicketUrl(e.target.value)}
            fullWidth
            margin="normal"
            variant="outlined"
          />
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center" }}>
          <SecondaryButton sx={{ border: "none" }} onClick={onClose}>
            Cancel
          </SecondaryButton>
          <PrimaryButton onClick={handleSave} disabled={!ticketUrl}>
            Save
          </PrimaryButton>
        </DialogActions>
      </Box>
    </Dialog>
  );
};
export default IssueLinkingModal;
